let entitydbRt = {
    "pinned": [
      "CompanyName"
    ],
    "width": {
      "CompanyName": 300
    },
    "immutable": {
      "CompanyName": false
    },
    "mapping": {
      "CompanyName": {
        "header": "Entity Name",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CompanyName"
      },
      "EntityStatus": {
        "header": "Entity Status",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "EntityStatus",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Active",
          "Dissolved",
          "In Liquidation",
          "Liquidated",
          "Struck Off"
        ]
      },
      "FundFamily": {
        "header": "Fund Family",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FundFamily",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Fund I",
          "Fund II",
          "Fund III",
          "Fund IV",
          "Fund V",
          "Fund VI",
          "Fund VII"
        ]
      },
      "Purpose": {
        "header": "Entity Purpose",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Purpose",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "AIV",
          "AIV Yukon",
          "Blocker",
          "Carry Vehicle",
          "Co-Investment",
          "Comingled Fund",
          "Feeder Fund",
          "General Partner",
          "Management Company",
          "Parallel Fund",
          "Partner Vehicle",
          "Separate Account",
          "Side Car",
          "Sleeve Fund",
          "SPV"
        ]
      },
      "Country": {
        "header": "Country",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Country",
        "cellEditor": "agTextCellEditor"
      },
      "column_8832ElectDate": {
        "header": "8832 Election Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "column_8832ElectDate",
        "cellEditor": "agTextCellEditor"
      },
      "column_8832ElectClass": {
        "header": "8832 Classification",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "column_8832ElectClass",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "A domestic eligible entity electing to be classified as an association taxable as a corporation.",
          "A domestic eligible entity electing to be classified as a partnership.",
          "A domestic eligible entity with a single owner electing to be disregarded as a separate entity.",
          "A foreign eligible entity electing to be classified as an association taxable as a corporation.",
          "A foreign eligible entity electing to be classified as a partnership.",
          "A foreign eligible entity with a single owner electing to be disregarded as a separate entity."
        ]
      },
      "GIIN": {
        "header": "FATCA Registration (GIIN)",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "GIIN",
        "cellEditor": "agTextCellEditor"
      },
      "FATCARegDate": {
        "header": "FATCA Registration Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FATCARegDate",
        "cellEditor": "agTextCellEditor"
      },
      "FATCACancelDate": {
        "header": "FATCA Cancellation Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FATCACancelDate",
        "cellEditor": "agTextCellEditor"
      },
      "FFARegNum": {
        "header": "DITC FI Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FFARegNum",
        "cellEditor": "agTextCellEditor"
      },
      "DITCRegDate": {
        "header": "DITC Registration Date",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "DITCRegDate",
        "cellEditor": "agTextCellEditor"
      },
      "DITCCancelDate": {
        "header": "DITC Cancellation Date",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "DITCCancelDate",
        "cellEditor": "agTextCellEditor"
      },
      "CIMANumber": {
        "header": "CIMA Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CIMANumber",
        "cellEditor": "agTextCellEditor"
      },
      "CIMARegDate": {
        "header": "CIMA Registration Date",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CIMARegDate",
        "cellEditor": "agTextCellEditor"
      },
      "CIMACancelDate": {
        "header": "CIMA Cancellation Date",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CIMACancelDate",
        "cellEditor": "agTextCellEditor"
      },
      "CFTCFiledDate": {
        "header": "CFTC Filed Date",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CFTCFiledDate",
        "cellEditor": "agTextCellEditor"
      },
      "ADVStatus": {
        "header": "Form ADV Status",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ADVStatus",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Private Fund",
          "Related Person",
          "Not Applicable"
        ]
      },
      "ADVFiler": {
        "header": "ADV Filer",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ADVFiler",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "PFFiler": {
        "header": "Form PF Filer",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PFFiler",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "SECFormDNum": {
        "header": "SEC Form D Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "SECFormDNum",
        "cellEditor": "agTextCellEditor"
      },
      "CIKNum": {
        "header": "SEC CIK Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CIKNum",
        "cellEditor": "agTextCellEditor"
      },
      "SECPrivFundID": {
        "header": "SEC Private Fund ID",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "SECPrivFundID",
        "cellEditor": "agTextCellEditor"
      },
      "FinraCRDNum": {
        "header": "FINRA CRD Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FinraCRDNum",
        "cellEditor": "agTextCellEditor"
      },
      "LEINumber": {
        "header": "LEI Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "LEINumber",
        "cellEditor": "agTextCellEditor"
      },
      "CancelDate": {
        "header": "LEI Cancel Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CancelDate",
        "cellEditor": "agTextCellEditor"
      },
      "AnnRptDueDate": {
        "header": "Annual Report Due Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AnnRptDueDate",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "March 31",
          "June 30",
          "September 30",
          "December 31",
          "Not Applicable"
        ]
      },
      "ERISAPlan": {
        "header": "ERISA Plan Asset",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ERISAPlan",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "ICAExempt": {
        "header": "Investment Company Act exemption",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ICAExempt",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "3(c)(1)",
          "3(c)(7)",
          "Not Applicable"
        ]
      },
      "CommodityPool": {
        "header": "Commodity pool?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CommodityPool",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "AIFMDReg1": {
        "header": "AIFMD Registration No 1",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AIFMDReg1",
        "cellEditor": "agTextCellEditor"
      },
      "AIFMDReg2": {
        "header": "AIFMD Registration No 2",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AIFMDReg2",
        "cellEditor": "agTextCellEditor"
      },
      "AIFMDReg3": {
        "header": "AIFMD Registration No 3",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AIFMDReg3",
        "cellEditor": "agTextCellEditor"
      },
      "AIFMDReg4": {
        "header": "AIFMD Registration No 4",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AIFMDReg4",
        "cellEditor": "agTextCellEditor"
      },
      "AddRegCountry": {
        "header": "Additional Registration Country",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AddRegCountry",
        "cellEditor": "agTextCellEditor"
      },
      "AddRegNum": {
        "header": "Additional Registration Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AddRegNum",
        "cellEditor": "agTextCellEditor"
      },
      "AddRegDate": {
        "header": "Additional Registration Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AddRegDate",
        "cellEditor": "agTextCellEditor"
      },
      "AltTaxID": {
        "header": "Alternate Tax ID",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AltTaxID",
        "cellEditor": "agTextCellEditor"
      }, 
      "LargeTraderID": {
        "header": "Large Trader ID 13H filings",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "LargeTraderID",
        "cellEditor": "agTextCellEditor"
      }
    }
  }
  export  { entitydbRt }
  
